<ui2-card-slideshow [title]="title" [class.center]="!clusterList.length" [cardCount]="clusterList?.length" [cardWidth]="clusterCardWidth">
  <ng-template #cardList>
    <!-- Cards list -->
    <ng-container *ngIf="!isListLoading; else loader">
      <ng-container *ngIf="clusterList.length; else noStories">
        @defer {
          <signals-cluster-card
            *ngFor="let cluster of clusterList"
            [data]="cluster"
            [firstClusterCardId]="firstClusterCardId"
            [selectedKeyEvent]="selectedKeyEvent"
            [currentlyOpenedStack]="currentlyOpenedStack"
            (clicked)="notifyClusterClick(cluster)"
          />
        }
      </ng-container>
    </ng-container>

    <!-- Loader -->
    <ng-template #loader>
      <ui-loader></ui-loader>
    </ng-template>

    <ng-template #noStories>
      <span class="no-stories label-sm">{{ 'strong-signals.noStories' | translate }}</span>
    </ng-template>
  </ng-template>
</ui2-card-slideshow>
